<template>
  <GridContainer
    class="samsung-usp-teaser"
    padding
  >
    <Heading
      class="samsung-usp-teaser__title"
      text-uppercase
      size="lg"
      font-weight="ultra"
      tag="h2"
      align="center"
    >
      {{ title }}
    </Heading>
    <Heading
      size="sm"
      class="samsung-usp-teaser__copy"
      align="center"
      font-weight="normal"
      tag="h3"
    >
      {{ copy }}
    </Heading>
    <ul class="samsung-usp-teaser__list">
      <li
        v-for="(item, index) in list"
        :key="`ecosystem-item-${index}`"
        class="samsung-usp-teaser__item"
      >
        <SvgIcon
          class="samsung-usp-teaser__logo-icon"
          :image="item.icon"
        />
        <Heading
          class="samsung-usp-teaser__item-title"
          size="sm"
          font-weight="ultra"
          tag="h4"
          align="center"
        >
          {{ item.title }}
        </Heading>
        <Paragraph
          is-size-big
          class="samsung-usp-teaser__item-copy"
          align="center"
        >
          {{ item.copy }}
        </Paragraph>
      </li>
    </ul>
  </GridContainer>
</template>

<script>
import { GridContainer, Heading, Paragraph } from '@i22-td-smarthome/component-library';
import IconSamsungGalxyWatch from 'assets/images/samsung/icon-samsung-galaxy-watch.svg';
import IconSamsungGalxySamrtphones from 'assets/images/samsung/icon-samsung-galaxy-smartphone.svg';
import IconSamsungGalxyBuds from 'assets/images/samsung/icon-samsung-galaxy-buds.svg';

export default {
  name: 'SamsungUspTeaser',
  components: {
    GridContainer,
    Heading,
    Paragraph,
  },
  data() {
    return {
      title: 'Perfekt verbunden im Galaxy Ecosystem',
      copy: 'Verbinde Dein Samsung Galaxy Smartphone nahtlos mit anderen Geräten der Galaxy Family',
      list: [
        {
          icon: IconSamsungGalxyWatch,
          title: 'Galaxy Watch – Dein persönlicher Fitnesstrainer',
          copy: 'Tracke Deine sportlichen Fortschritte und lass Dir über die kabellosen Galaxy Buds Trainingstipps in Echtzeit geben. Lade die Galaxy Watch ganz einfach per Wireless PowerShare mit Deinem Samsung Galaxy Smartphone auf und sei immer mobil erreichbar.',
        },
        {
          icon: IconSamsungGalxySamrtphones,
          title: 'Die neue Generation Samsung Galaxy Smartphones',
          copy: 'Mit Deinem Samsung Smartphone und dem praktischen Zubehör organisierst Du ganz komfortabel Deinen Alltag, telefoniere, informiere dich online, mache Notizen oder sorge für Unterhaltung, z.B. mit Musik über die kabellosen Galaxy Buds.',
        },
        {
          icon: IconSamsungGalxyBuds,
          title: 'Samsung Galaxy Buds',
          copy: 'Musik hören, Telefonate mit ausgezeichneter Sprachqualität führen oder Sprachsteuerung nutzen. Die Kopfhörer verbinden sich automatisch mit dem jeweils genutzten Gerät ob Galaxy Watch, Samsung Smartphone oder Tablet.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.samsung-usp-teaser {
  &__list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    @include mq($mq-sm) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &__copy {
    font-weight: normal;
  }

  &__logo-icon {
    height: 60px;
    width: auto;
  }
  &__item {
    border: 1px solid color(grey, 18500);
    list-style: none;
    padding: 1rem;
    text-align: center;
    @include mq($mq-md) {
      padding: 2rem;
    }
  }

  &__copy,
  &__title {
    padding-bottom: 1rem;
  }

  &__item-copy {
    margin: 0;
  }
  &__item-title {
    padding: 1rem 0;
  }
}
</style>
